import { formatMatrixCode } from '@/entities/GeneratedRecord';

export function buildMatrixTitle(matrix: { prefix: string; title: string | null }): string {
  const code = formatMatrixCode(matrix.prefix);
  return matrix.title ? `${code} - ${matrix.title}` : code;
}
